import type { User } from './auth';

const DEVELOPER_ROLES = new Set(['platform_admin', 'developer', 'tenant_developer']);
const TECHNICAL_GRANTS = new Set([
  'developer:technical',
  'technical:read',
  'perf:read',
  'debug:read',
  'runtime:debug',
]);

function normalize(value: string | undefined | null): string {
  return (value ?? '').trim().toLowerCase();
}

export function isTenantDeveloperUser(user: Pick<User, 'email' | 'role' | 'grants' | 'tenantSlug'> | null | undefined): boolean {
  if (!user) return false;
  const role = normalize(user.role);
  if (DEVELOPER_ROLES.has(role)) return true;
  if (user.grants?.some((grant) => TECHNICAL_GRANTS.has(grant))) return true;

  const tenantSlug = normalize(user.tenantSlug);
  if (!tenantSlug) return false;
  return normalize(user.email) === `boox@${tenantSlug}`;
}

export function isTechnicalPermission(permission: string | undefined): boolean {
  if (!permission) return false;
  return permission === 'developer:technical' || permission.startsWith('technical:');
}
